import React from 'react';
import { images } from '../../../../Constants/ImageUrls';
import PrSection from '../PrSection/PrSection';
import { BannerContainer, TopFooterWave } from './styled';

export default function index({ installLink, isAboutUsPage }) {
  return (
    <BannerContainer isAboutUsPage={isAboutUsPage}>
      <TopFooterWave
        loading="lazy"
        src={images.FooterTopWave}
        alt="foot top wave"
        topBg="#eff0f0"
        top="0"
      />
      <TopFooterWave
        loading="lazy"
        src={images.FooterBottomWave}
        alt="foot down wave"
        bottom="0"
        bottomtrans
      />
      <PrSection />
      {/* <BannerContent>
                <GetMyloSection> */}
      {/* <div>
                        <GetMylo>Get Mylo Baby App</GetMylo>
                        {/* <RaiseHappiness>
                            Raising Happiness of 10+ Million
                        </RaiseHappiness> */}
      {/* <RaiseHappiness>
                            {
                                "Learn about your baby's growth from experts & 1 Cr+ parents"
                            }
                        </RaiseHappiness> */}
      {/* </div> */}{' '}
      {/* <div>
                    <QRCode
                        loading="lazy"
                        src={images.qrCode}
                        alt="mylo QR Code"
                    />
                    <ScanToInstall>Scan to Install</ScanToInstall>
                </div> */}
      {/* <PlaystoreButton installLink={installLink} />
                </GetMyloSection>
                <div>
                    <MobileImage
                        loading="lazy"
                        src={images.myloMobile}
                        alt="Mylo mobile"
                        width="132"
                        height="140"
                    />
                </div> */}
      {/* </BannerContent> */}
    </BannerContainer>
  );
}
